export const VIEW_MODE_EDITOR = 'editor';
export const VIEW_MODE_PREVIEW = 'preview';
export const VIEW_MODE_SITE = 'site';
export const VIEW_MODE_SEO = 'viewer-seo';

export type VIEW_MODE = 'editor' | 'preview' | 'site' | 'viewer-seo';
// To do: enum
